import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MercadoriasModel } from "./mercadorias.model";
import { MercadoriasService } from './mercadorias.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";
import { MercadoriasDefeitosService } from "../mercadorias-defeitos/mercadorias-defeitos.service";
import { MercadoriasVariedadesService } from "../mercadorias-variedades/mercadorias-variedades.service";
import { MercadoriasClassificacaoService } from "../mercadorias-classificacao/mercadorias-classificacao.service";
import { UnidadesMedidasService } from "../unidades-medidas/unidades-medidas.service";

declare let $, swal: any;

@Component({
  selector: 'app-mercadorias-form',
  templateUrl: './mercadorias-form.component.html'
})
export class MercadoriasFormComponent implements OnInit {

  form: FormGroup;
  formFoto: FormGroup;
  title: string;
  mercadoria: MercadoriasModel = new MercadoriasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  listIndicesConclusao = [];
  listCores = [
    { "nome": "Verde", "valor": 1 },
    { "nome": "Amarelo", "valor": 2 },
    { "nome": "Vermelho", "valor": 0 }
  ];
  listCalcPeso = [];
  cor: number = null;

  novoInputLabelPt: string = '';
  novoInputLabelEn: string = '';
  novoInputLabelEs: string = '';

  iIndice; // guarda o index que será adicionado / editado um indice
  iItem; // guarda o index do item que será editado de um indice de conclusao
  nomeIncicePT: string = ''; // model com o nome em pt do indice que será adicionado ou editado
  nomeInciceEN: string = ''; // model com o nome em en do indice que será adicionado ou editado
  nomeInciceES: string = ''; // model com o nome em es do indice que será adicionado ou editado
  valorIndice: string = ''; // model com o valor do item do indice
  ordemIndice: number = 0; // model com a ordem do item do indice
  classificar: boolean = false; // indica se o indice deve ser considerado na classificação
  observacaoPt: string = '';
  observacaoEn: string = '';
  observacaoEs: string = '';
  status: boolean = true;

  srcFoto = this.global.dominio_site + '/mercadorias/sem-foto.jpg';

  carregandoTabelaDefeitos: boolean = true;
  listDefeitos = [];

  carregandoTabelaVariedades: boolean = true;
  listVariedades = [];

  carregandoTabelaIndicesClassificacao: boolean = true;
  listIndicesClassificacao = [];
  listUnidadesMedidas = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasService: MercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global,
    private mercadoriasDefeitosService: MercadoriasDefeitosService,
    private mercadoriasVariedadesService: MercadoriasVariedadesService,
    private mercadoriasClassificacaoService: MercadoriasClassificacaoService,
    private unidadesMedidasService: UnidadesMedidasService
  ) {

    this.formFoto = formBuilder.group({
      foto: [],
    });

    this.listCalcPeso = [
      { nome: this.func.traduzir('front.pesoBruto'), valor: "peso_bruto" },
      { nome: this.func.traduzir('front.pesoDrenado'), valor: "peso_drenado" },
      { nome: this.func.traduzir('front.pesoLiquido'), valor: "peso_liquido" }
    ];

    this.form = formBuilder.group({
      id: [],
      nome_padrao: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      ncm: [],
      portaria0: [],
      portaria_data0: [],
      instrucao0: [],
      instrucao_data0: [],
      tempo_emitir_cert_mi: ['', [
        Validators.required
      ]],
      classificar: [],
      status: [],
      laudo_tec_exibir_peso_bruto: [],
      laudo_tec_exibir_peso_drenado: [],
      laudo_tec_exibir_peso_liquido: [],
      laudo_tec_calc_peso: [],
      laudo_tec_exibir_temp_polpa: [],
      laudo_tec_exibir_brix: [],
      laudo_tec_exibir_pressao_polpa: [],
      laudo_tec_calibre_multiplo: [],
      laudo_tec_layout_calibre_com_valores: [],
      laudo_tec_id_unidade_medida: []
    });
  }

  ngOnInit() {

    this.unidadesMedidasService.get().subscribe(
      json => {
        this.listUnidadesMedidas = json.Payload || [];
      },
      error => {
        console.error("Erro ao carregar unidades de medida", error);
      }
    );

    const urlPath = this.router.url.split('?')[0];
    const lastSegment = urlPath.split(/\//).pop();

    // verifica se é uma página de edição
    if (lastSegment == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (lastSegment == 'add') {
      this.pageIsAdd = true;
    }

    this.route.queryParams.subscribe(queryParams => {
      let duplicateId = queryParams['duplicate_id'];
      if (duplicateId && this.pageIsAdd) {
        this.mercadoriasService.getById(duplicateId, ["indices_conclusao"])
          .subscribe(
            json => {
              if (json && json.Payload && json.Payload[0]) {
                const source = json.Payload[0];
                this.mercadoria.nome_padrao = source.nome_padrao;
                this.mercadoria.nome_pt = source.nome_pt;
                this.mercadoria.nome_en = source.nome_en;
                this.mercadoria.nome_es = source.nome_es;
                this.mercadoria.ncm = source.ncm;
                this.mercadoria.tempo_emitir_cert_mi = source.tempo_emitir_cert_mi;
                this.mercadoria.laudo_tec_exibir_peso_bruto = source.laudo_tec_exibir_peso_bruto;
                this.mercadoria.laudo_tec_exibir_peso_drenado = source.laudo_tec_exibir_peso_drenado;
                this.mercadoria.laudo_tec_exibir_peso_liquido = source.laudo_tec_exibir_peso_liquido;
                this.mercadoria.laudo_tec_calc_peso = source.laudo_tec_calc_peso;
                this.mercadoria.laudo_tec_exibir_temp_polpa = source.laudo_tec_exibir_temp_polpa;
                this.mercadoria.laudo_tec_exibir_brix = source.laudo_tec_exibir_brix;
                this.mercadoria.laudo_tec_exibir_pressao_polpa = source.laudo_tec_exibir_pressao_polpa;
                this.mercadoria.laudo_tec_calibre_multiplo = source.laudo_tec_calibre_multiplo;
                this.mercadoria.laudo_tec_layout_calibre_com_valores = source.laudo_tec_layout_calibre_com_valores;
                this.mercadoria.laudo_tec_id_unidade_medida = source.laudo_tec_id_unidade_medida;
                if (this.mercadoria.laudo_tec_id_unidade_medida === 'null' || this.mercadoria.laudo_tec_id_unidade_medida === '0' || (this.mercadoria.laudo_tec_id_unidade_medida as any) === 0 || !this.mercadoria.laudo_tec_id_unidade_medida) {
                  this.mercadoria.laudo_tec_id_unidade_medida = null;
                }

                // portarias
                let loadedPortarias = source.portarias;
                if (typeof loadedPortarias === 'string' && loadedPortarias !== '') {
                  try {
                    loadedPortarias = JSON.parse(loadedPortarias);
                  } catch (e) {
                    loadedPortarias = [];
                  }
                }
                if (!loadedPortarias || !Array.isArray(loadedPortarias) || loadedPortarias.length === 0) {
                  loadedPortarias = [{ "portaria": null, "portaria_data": null }];
                }
                this.mercadoria.portarias = JSON.parse(JSON.stringify(loadedPortarias));

                for (let z in this.mercadoria.portarias) {
                  this.form.addControl('portaria' + z, new FormControl('portaria' + z, []));
                  this.form.addControl('portaria_data' + z, new FormControl('portaria_data' + z, []));
                }

                // instrucoes normativas
                let loadedInstrucoes = source.instrucoes_normativas;
                if (typeof loadedInstrucoes === 'string' && loadedInstrucoes !== '') {
                  try {
                    loadedInstrucoes = JSON.parse(loadedInstrucoes);
                  } catch (e) {
                    loadedInstrucoes = [];
                  }
                }
                if (!loadedInstrucoes || !Array.isArray(loadedInstrucoes) || loadedInstrucoes.length === 0) {
                  loadedInstrucoes = [{ "instrucao": null, "data": null }];
                }
                this.mercadoria.instrucoes_normativas = JSON.parse(JSON.stringify(loadedInstrucoes));

                for (let z in this.mercadoria.instrucoes_normativas) {
                  this.form.addControl('instrucao' + z, new FormControl('instrucao' + z, []));
                  this.form.addControl('instrucao_data' + z, new FormControl('instrucao_data' + z, []));
                }
              }
            },
            error => {
              this.func.showErro(error.json());
            }
          );
      }
    });

    this.route.params.subscribe(params => {
      let id = params['id_mercadoria'];

      if (this.pageIsAdd) {
        this.title = this.func.traduzir('front.cadastrarNovaMercadoria');
      } else if (this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarMercadoria');
      } else {
        this.title = this.func.traduzir('front.visualizarMercadoria');
      }

      if (!id) {
        return;
      }

      this.mercadoriasService.getById(id, ["indices_conclusao"])
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarMercadoria') + ': ' + json.Payload[0].nome_pt;
            } else {
              this.title = this.func.traduzir('front.visualizarMercadoria') + ': ' + json.Payload[0].nome_pt;
            }

            this.listIndicesConclusao = json.Payload[0].indices_conclusao;

            // adiciona formularios de portarias
            let loadedPortarias = json.Payload[0].portarias;
            if (typeof loadedPortarias === 'string' && loadedPortarias !== '') {
              try {
                loadedPortarias = JSON.parse(loadedPortarias);
              } catch (e) {
                console.error("Erro ao fazer parse de portarias", e);
                loadedPortarias = [];
              }
            }
            if (!loadedPortarias || !Array.isArray(loadedPortarias) || loadedPortarias.length === 0) {
              loadedPortarias = [{ "portaria": null, "portaria_data": null }];
            }
            json.Payload[0].portarias = loadedPortarias;

            for (let z in json.Payload[0].portarias) {
              console.log('adicionado', 'portaria' + z);
              this.form.addControl('portaria' + z, new FormControl('portaria' + z, []));
              this.form.addControl('portaria_data' + z, new FormControl('portaria_data' + z, []));
            }

            // adiciona formularios de instrucoes normativas
            let loadedInstrucoes = json.Payload[0].instrucoes_normativas;
            if (typeof loadedInstrucoes === 'string' && loadedInstrucoes !== '') {
              try {
                loadedInstrucoes = JSON.parse(loadedInstrucoes);
              } catch (e) {
                console.error("Erro ao fazer parse de instrucoes normativas", e);
                loadedInstrucoes = [];
              }
            }
            if (!loadedInstrucoes || !Array.isArray(loadedInstrucoes) || loadedInstrucoes.length === 0) {
              loadedInstrucoes = [{ "instrucao": null, "data": null }];
            }
            json.Payload[0].instrucoes_normativas = loadedInstrucoes;

            for (let z in json.Payload[0].instrucoes_normativas) {
              console.log('adicionado', 'instrucao' + z);
              this.form.addControl('instrucao' + z, new FormControl('instrucao' + z, []));
              this.form.addControl('instrucao_data' + z, new FormControl('instrucao_data' + z, []));
            }

            this.mercadoria = json.Payload[0];
            if (this.mercadoria.laudo_tec_id_unidade_medida === 'null' || this.mercadoria.laudo_tec_id_unidade_medida === '0' || (this.mercadoria.laudo_tec_id_unidade_medida as any) === 0 || !this.mercadoria.laudo_tec_id_unidade_medida) {
              this.mercadoria.laudo_tec_id_unidade_medida = null;
            }
            this.carregaTabelaDefeitos();

            // Garantir que odr_inputs_config esteja inicializado
            if (!this.mercadoria.odr_inputs_config) {
              this.mercadoria.odr_inputs_config = [];
            }

            if (this.mercadoria.com_foto) {
              this.srcFoto = this.global.dominio_site + '/mercadorias/' + this.mercadoria.id + '/foto.jpg';
            }

            if (this.route.snapshot.queryParams['abaindices'] == '1') {
              setTimeout(() => {
                $('a[href="#indices_classificacao"]').click();
              }, 100);
            }

            if (this.route.snapshot.queryParams['abadefeitos'] == '1') {
              this.carregaTabelaDefeitos();
              setTimeout(() => {
                $('a[href="#defeitos"]').click();
              }, 100);
            }

            if (this.route.snapshot.queryParams['abavariedades'] == '1') {
              this.carregaTabelaVariedades();
              setTimeout(() => {
                $('a[href="#variedades"]').click();
              }, 100);
            }

            if (this.global.debug == true) {
              console.log('Mercadoria', json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  modalAddIndiceConclusao() {
    this.nomeIncicePT = '';
    this.nomeInciceEN = '';
    this.nomeInciceES = '';
    this.classificar = false;

    $('#modalAddIndice').modal('show');
  }

  addIndiceConclusao() {

    this.listIndicesConclusao.push({
      id_indice: null,
      id_mercadoria: null,
      itens: [],
      nome_en: this.nomeInciceEN,
      nome_es: this.nomeInciceES,
      nome_pt: this.nomeIncicePT,
      classificar: this.classificar,
      ordem: this.listIndicesConclusao.length + 1
    });

    this.nomeIncicePT = '';
    this.nomeInciceEN = '';
    this.nomeInciceES = '';
    this.classificar = false;

    $('#modalAddIndice').modal('hide');
  }

  modalUpdIndice(iIndice) {
    this.iIndice = iIndice;
    this.nomeIncicePT = this.listIndicesConclusao[this.iIndice].nome_pt;
    this.nomeInciceEN = this.listIndicesConclusao[this.iIndice].nome_en;
    this.nomeInciceES = this.listIndicesConclusao[this.iIndice].nome_es;
    this.classificar = !!this.listIndicesConclusao[this.iIndice].classificar;

    $('#modalUpdIndice').modal('show');
  }

  updIndiceConclusao() {
    this.listIndicesConclusao[this.iIndice].nome_pt = this.nomeIncicePT;
    this.listIndicesConclusao[this.iIndice].nome_en = this.nomeInciceEN;
    this.listIndicesConclusao[this.iIndice].nome_es = this.nomeInciceES;
    this.listIndicesConclusao[this.iIndice].classificar = this.classificar;

    $('#modalUpdIndice').modal('hide');
  }

  deleteIndice(iIndice) {

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarIndiceConclusao'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.listIndicesConclusao.splice(iIndice, 1);
      });

  }

  modalAddItemIndice(indice) {
    this.iIndice = indice;
    this.nomeIncicePT = '';
    this.nomeInciceEN = '';
    this.nomeInciceES = '';
    this.valorIndice = '';
    this.ordemIndice = 0;
    this.observacaoPt = '';
    this.observacaoEn = '';
    this.observacaoEs = '';
    this.status = true;
    this.cor = null;

    $('#modalAddItemIndice').modal('show');
  }

  addItemIndiceConclusao() {

    this.listIndicesConclusao[this.iIndice].itens.push({
      id_indice: this.listIndicesConclusao[this.iIndice].id_indice,
      id_item: null,
      nome_pt: this.nomeIncicePT,
      nome_en: this.nomeInciceEN,
      nome_es: this.nomeInciceES,
      valor: this.valorIndice,
      ordem: this.listIndicesConclusao[this.iIndice].itens.length,
      ordem_classificacao: this.ordemIndice,
      observacao_pt: this.observacaoPt ? this.observacaoPt.toUpperCase() : '',
      observacao_en: this.observacaoEn ? this.observacaoEn.toUpperCase() : '',
      observacao_es: this.observacaoEs ? this.observacaoEs.toUpperCase() : '',
      status: this.status,
      cor: this.cor !== null && this.cor !== undefined ? Number(this.cor) : null
    });

    this.iIndice = null;
    this.nomeIncicePT = '';
    this.nomeInciceEN = '';
    this.nomeInciceES = '';
    this.valorIndice = '';
    this.ordemIndice = 0;
    this.observacaoPt = '';
    this.observacaoEn = '';
    this.observacaoEs = '';
    this.status = true;
    this.cor = null;

    $('#modalAddItemIndice').modal('hide');
  }

  modalUpdItemIndice(iIndice, iItem) {
    this.iIndice = iIndice;
    this.iItem = iItem;
    this.nomeIncicePT = this.listIndicesConclusao[this.iIndice].itens[iItem].nome_pt;
    this.nomeInciceEN = this.listIndicesConclusao[this.iIndice].itens[iItem].nome_en;
    this.nomeInciceES = this.listIndicesConclusao[this.iIndice].itens[iItem].nome_es;
    this.valorIndice = this.listIndicesConclusao[this.iIndice].itens[iItem].valor || '';
    this.ordemIndice = this.listIndicesConclusao[this.iIndice].itens[iItem].ordem_classificacao || 0;
    this.observacaoPt = (this.listIndicesConclusao[this.iIndice].itens[iItem].observacao_pt || '').toUpperCase();
    this.observacaoEn = (this.listIndicesConclusao[this.iIndice].itens[iItem].observacao_en || '').toUpperCase();
    this.observacaoEs = (this.listIndicesConclusao[this.iIndice].itens[iItem].observacao_es || '').toUpperCase();
    this.status = this.listIndicesConclusao[this.iIndice].itens[iItem].status !== undefined ? !!this.listIndicesConclusao[this.iIndice].itens[iItem].status : true;
    this.cor = this.listIndicesConclusao[this.iIndice].itens[iItem].cor !== undefined && this.listIndicesConclusao[this.iIndice].itens[iItem].cor !== null ? Number(this.listIndicesConclusao[this.iIndice].itens[iItem].cor) : null;

    $('#modalUpdItemIndice').modal('show');
  }

  updItemIndiceConclusao() {

    this.listIndicesConclusao[this.iIndice]['itens'][this.iItem] = {
      id_indice: this.listIndicesConclusao[this.iIndice].id_indice,
      id_item: this.listIndicesConclusao[this.iIndice]['itens'][this.iItem].id_item,
      nome_pt: this.nomeIncicePT,
      nome_en: this.nomeInciceEN,
      nome_es: this.nomeInciceES,
      valor: this.valorIndice,
      ordem: this.listIndicesConclusao[this.iIndice]['itens'][this.iItem].ordem,
      ordem_classificacao: this.ordemIndice,
      observacao_pt: this.observacaoPt ? this.observacaoPt.toUpperCase() : '',
      observacao_en: this.observacaoEn ? this.observacaoEn.toUpperCase() : '',
      observacao_es: this.observacaoEs ? this.observacaoEs.toUpperCase() : '',
      status: this.status,
      cor: this.cor !== null && this.cor !== undefined ? Number(this.cor) : null
    };

    this.iIndice = null;
    this.iItem = null;
    this.nomeIncicePT = '';
    this.nomeInciceEN = '';
    this.nomeInciceES = '';
    this.valorIndice = '';
    this.ordemIndice = 0;
    this.observacaoPt = '';
    this.observacaoEn = '';
    this.observacaoEs = '';
    this.status = true;
    this.cor = null;

    $('#modalUpdItemIndice').modal('hide');
  }

  deleteItemIndice(iIndice, iItem) {

    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarItemIndiceConclusao'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.listIndicesConclusao[iIndice]['itens'].splice(iItem, 1);
      });

  }

  addPortaria() {
    if (!this.mercadoria.portarias || !Array.isArray(this.mercadoria.portarias)) {
      this.mercadoria.portarias = [];
    }
    console.log('adicionado', this.mercadoria.portarias.length);
    const len = this.mercadoria.portarias.length;
    this.form.addControl('portaria' + len, new FormControl('portaria' + len, []));
    this.form.addControl('portaria_data' + len, new FormControl('portaria_data' + len, []));

    this.mercadoria.portarias.push({ "portaria": null, "portaria_data": null });
  }

  removePortaria(i) {
    if (this.mercadoria.portarias && Array.isArray(this.mercadoria.portarias)) {
      this.mercadoria.portarias.splice(i, 1);
    }
  }

  addInstrucaoNormativa() {
    if (!this.mercadoria.instrucoes_normativas || !Array.isArray(this.mercadoria.instrucoes_normativas)) {
      this.mercadoria.instrucoes_normativas = [];
    }
    console.log('adicionado instrucao', this.mercadoria.instrucoes_normativas.length);
    const len = this.mercadoria.instrucoes_normativas.length;
    this.form.addControl('instrucao' + len, new FormControl('instrucao' + len, []));
    this.form.addControl('instrucao_data' + len, new FormControl('instrucao_data' + len, []));

    this.mercadoria.instrucoes_normativas.push({ "instrucao": null, "data": null });
  }

  removeInstrucaoNormativa(i) {
    if (this.mercadoria.instrucoes_normativas && Array.isArray(this.mercadoria.instrucoes_normativas)) {
      this.mercadoria.instrucoes_normativas.splice(i, 1);
    }
  }

  voltar() {
    this._location.back();
  }

  save() {

    this.enviando = true;
    this.mercadoria['indices_conclusao'] = this.listIndicesConclusao;

    if (this.mercadoria.laudo_tec_id_unidade_medida === 'null' || this.mercadoria.laudo_tec_id_unidade_medida === '0' || (this.mercadoria.laudo_tec_id_unidade_medida as any) === 0 || !this.mercadoria.laudo_tec_id_unidade_medida) {
      this.mercadoria.laudo_tec_id_unidade_medida = null;
    }

    let result,
      values = this.mercadoria; //this.form.value;

    if (values.id) {
      result = this.mercadoriasService.editar(values, values.id);
    } else {
      result = this.mercadoriasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'mercadorias']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }

  uploadFotoComplete(resp) {
    try {
      let json = JSON.parse(resp);
      if (json.Success) {
        this.srcFoto = this.global.dominio_site + '/mercadorias/' + this.mercadoria.id + '/foto.jpg?t=' + new Date().getTime();
        this.mercadoria.com_foto = true;
      }
    }
    catch (e) { }
  }

  apagaFoto() {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFoto'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.mercadoriasService.apagarFoto(self.mercadoria.id)
          .subscribe(
            json => {
              if (json.Success) {
                self.srcFoto = self.global.dominio_site + '/mercadorias/sem-foto.jpg';
                self.mercadoria.com_foto = false;
              }
            },
            error => {
              self.func.showErro(error.json());
            });
      });
  }

  carregaTabelaDefeitos() {
    if (this.carregandoTabelaDefeitos) {
      this.mercadoriasDefeitosService.get(['unidade_medida'], { "id_mercadoria": this.mercadoria.id })
        .subscribe(data => {
          this.listDefeitos = data['Payload'];
          this.carregandoTabelaDefeitos = false;
        },
          error => {
            this.func.showErro(error.json());
            this.carregandoTabelaDefeitos = false;
          });
    }

  }

  deleteDefeito(defeito) {
    let defeitos = this.listDefeitos;
    let mercadoriasDefeitosService = this.mercadoriasDefeitosService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarDefeito') + defeito.nome_pt,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(defeitos);
        }

        let index = defeitos.indexOf(defeito);
        defeitos.splice(index, 1);

        mercadoriasDefeitosService.apagar(defeito.id)
          .subscribe(res => {
            self.listDefeitos = defeitos;
          },
            err => {
              // Revert the view back to its original state
              defeitos.splice(index, 0, defeito);
              self.listDefeitos = defeitos;

              self.func.showErro(err.json());
            });

      });
  }

  ordenouDefeitos(e) {
    console.log(e);
    console.log(this.listDefeitos);

    for (let i in this.listDefeitos) {
      console.log('indice', this.listDefeitos[i]);
      this.listDefeitos[i].ordem = parseInt(i) + 1;
    }

    this.mercadoriasDefeitosService.ordenaIndices(this.listDefeitos)
      .subscribe(json => {
        console.log(json);
      });

  }

  carregaTabelaVariedades() {
    if (this.carregandoTabelaVariedades) {
      this.mercadoriasVariedadesService.get(null, { "id_mercadoria": this.mercadoria.id })
        .subscribe(data => {
          this.listVariedades = data['Payload'];
          this.carregandoTabelaVariedades = false;
        },
          error => {
            this.func.showErro(error.json());
            this.carregandoTabelaVariedades = false;
          });
    }

  }

  deleteVariedade(variedade) {
    let variedades = this.listVariedades;
    let mercadoriasVariedadesService = this.mercadoriasVariedadesService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarMercadoriaVariedade') + variedade.nome,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(variedades);
        }

        let index = variedades.indexOf(variedade);
        variedades.splice(index, 1);

        mercadoriasVariedadesService.apagar(variedade.id)
          .subscribe(res => {
            self.listVariedades = variedades;
          },
            err => {
              // Revert the view back to its original state
              variedades.splice(index, 0, variedade);
              self.listVariedades = variedades;

              self.func.showErro(err.json());
            });

      });
  }

  validateForm(form) {
    for (let i in form['controls']) {
      this.form['controls'][i].markAsTouched();
    }
  }

  ordenouIndicesConclusao(e) {
    for (let i in this.listIndicesConclusao) {
      console.log('indice', this.listIndicesConclusao[i]);
      this.listIndicesConclusao[i].ordem = parseInt(i) + 1;
    }
  }

  ordenouItensIndicesConclusao(e, indiceConclusao) {
    for (let i in this.listIndicesConclusao[indiceConclusao].itens) {
      console.log('indice', this.listIndicesConclusao[indiceConclusao].itens[i]);
      this.listIndicesConclusao[indiceConclusao].itens[i].ordem = parseInt(i);
    }
    console.log(this.listIndicesConclusao[indiceConclusao].itens);
  }

  inserirTokenFormula(token: string) {
    if (!this.mercadoria.formula_odr) {
      this.mercadoria.formula_odr = '';
    }
    if (this.mercadoria.formula_odr.length > 0 && !this.mercadoria.formula_odr.endsWith(' ')) {
      this.mercadoria.formula_odr += ' ';
    }
    this.mercadoria.formula_odr += token;
  }

  apagarUltimoToken() {
    if (!this.mercadoria.formula_odr) return;
    let expr = this.mercadoria.formula_odr.trim();
    let parts = expr.split(' ');
    parts.pop();
    this.mercadoria.formula_odr = parts.join(' ');
  }

  adicionarInputCustomizado() {
    if (!this.novoInputLabelPt) return;
    let rawLabel = this.novoInputLabelPt as any;
    let chave = (rawLabel.normalize ? rawLabel.normalize("NFD") : rawLabel)
      .toLowerCase()
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9_]/g, "_")
      .replace(/_+/g, "_")
      .trim();
    if (!chave) return;

    if (!this.mercadoria.odr_inputs_config) {
      this.mercadoria.odr_inputs_config = [];
    }

    if (this.mercadoria.odr_inputs_config.some(item => item.chave === chave)) {
      this.func.alerta('Aviso', 'Um campo com essa chave já foi adicionado!', 'erro');
      return;
    }

    this.mercadoria.odr_inputs_config.push({
      chave: chave,
      label_pt: this.novoInputLabelPt,
      label_en: this.novoInputLabelEn || this.novoInputLabelPt,
      label_es: this.novoInputLabelEs || this.novoInputLabelPt
    });
    this.novoInputLabelPt = '';
    this.novoInputLabelEn = '';
    this.novoInputLabelEs = '';
  }

  removerInputCustomizado(chave: string) {
    if (this.mercadoria.odr_inputs_config) {
      this.mercadoria.odr_inputs_config = this.mercadoria.odr_inputs_config.filter(item => item.chave !== chave);
      if (this.mercadoria.formula_odr) {
        this.mercadoria.formula_odr = this.mercadoria.formula_odr.replace(new RegExp('\\{input_' + chave + '\\}', 'g'), '');
      }
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/mercadorias/mercadorias-form.component.ts